import { useEffect, useRef } from 'react';

import { SipSessionEventBus } from 'features/sip/services';

interface UseDtmfSubscriptionProps {
  participantId: string | null;
  onIncomingDtmf: (request: { body: string }) => void;
}

export const useDtmfSubscription = ({
  participantId,
  onIncomingDtmf,
}: UseDtmfSubscriptionProps) => {
  // Ref to hold the latest callback to avoid stale closures
  const onIncomingDtmfRef = useRef(onIncomingDtmf);

  // Keep the ref updated with the latest callback
  useEffect(() => {
    onIncomingDtmfRef.current = onIncomingDtmf;
  }, [onIncomingDtmf]);

  // Create subscription only when participantId changes
  useEffect(() => {
    if (!participantId) {
      return;
    }

    const subscription = SipSessionEventBus.incomingDtmf$.subscribe(
      (request) => {
        onIncomingDtmfRef.current(request);
      }
    );

    return () => {
      subscription.unsubscribe();
    };
  }, [participantId]);
};
